var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-file-input',{attrs:{"id":"fileInput","dense":"","label":"File input","disabled":_vm.disabled,"multiple":_vm.multiple,"accept":_vm.conditionAccept},on:{"change":function($event){return _vm.$emit('change',$event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }